import React, { FC, ReactElement, useContext, useRef } from 'react';
import { ShopPageDatesHeaderProps } from './shopPageDatesHeader.types';
import { StyledShopPageDatesHeaderDiv, StyledShopPageDateBoxDiv } from './shopPageDatesHeader.styles';
import { ContentContext, ViewportContext } from '../../index.contexts';
import { isCNLocale } from '@marriott/shared/mi-helper-utils';
import { IS_LOCALE_ZH_TW } from '../../../constants/ApplicationConstants';
import { usePageContext } from '../../../../../../context/PageContext';
import { convertArabicToEnglishNumbers, getLocaleFromDocument } from '../../../../../../utils/src/helper';
import { AR_LOCALE } from '../../../../../../modules/constants/Calendar.constants';

const ShopPageDatesHeaderBox: FC<ShopPageDatesHeaderProps> = ({
  checkInDate,
  checkOutDate,
  onClickCheckIn,
  onClickCheckOut,
  focusedCheckIn = null,
  isADFPage = false,
}) => {
  const { checkInLabel, checkOutLabel, datesPlaceholderText } = useContext(ContentContext);
  const isMobileView = useContext(ViewportContext);
  const clickTrackingLoc = 'Search Form';
  const { currentLocale } = usePageContext();
  const maxDateLength = checkInDate?.length > checkOutDate?.length ? checkInDate?.length : checkOutDate?.length;

  const isCurrentLocaleCN = isCNLocale(currentLocale) || currentLocale === IS_LOCALE_ZH_TW;

  /**
   * Return react element to display check in/out date and clear button
   * @param label
   * @param date
   * @param onClearHandler
   * @param onClickHandler
   * @param focused
   */
  const DateBox = (label: string, date: string, onClickHandler: () => void, focused: boolean): ReactElement => {
    const mainBtn = useRef<HTMLButtonElement>(null);
    const dateLength = date?.length;
    date = getLocaleFromDocument() === AR_LOCALE ? convertArabicToEnglishNumbers(date) : date;

    return (
      // CNWEB-2933 made the following changes because the Chinese date format is not fully displayed
      <StyledShopPageDateBoxDiv
        data-component-name="a-shop-ShopPageDatesHeaderBox"
        data-testid="shop-ShopPageDatesHeaderBox"
        focused={focused}
        isCNLocale={isCurrentLocaleCN}
        currentLocale={currentLocale}
        dateLength={dateLength}
      >
        <button
          type="button"
          ref={mainBtn}
          className={`date-button  custom_click_track`}
          {...{ custom_click_track_value: `${clickTrackingLoc}| Date Picker ${label} button |internal` }}
          aria-expanded={focused}
          onClick={onClickHandler}
        >
          {/* flag added to hide icons incase of ADF Page */}
          <span
            className={`search__calendar-label calendar-text-ellipsis ${isADFPage ? '' : 'icon-nav---book'} t-label-xs`}
          >
            {label}
          </span>
          <span
            //prettier-ignore
            className={`${isMobileView? 't-subtitle-inverse-l': dateLength >= 26 ? 't-subtitle-s': dateLength >= 16 && dateLength < 26 ? 't-subtitle-m': dateLength >= 12 && dateLength < 16 ? 't-subtitle-l': 't-subtitle-xl'} search-page-date-text ${!date ? 'gray-shade' : ''}`}
          >
            {date ? date : datesPlaceholderText}
          </span>
        </button>
      </StyledShopPageDateBoxDiv>
    );
  };

  return (
    // prop added to customise styles based on the page
    <StyledShopPageDatesHeaderDiv isADFPage={isADFPage} dateLength={maxDateLength}>
      {DateBox(checkInLabel, checkInDate, onClickCheckIn, focusedCheckIn ?? false)}
      {DateBox(checkOutLabel, checkOutDate, onClickCheckOut, focusedCheckIn === null ? false : !focusedCheckIn)}
    </StyledShopPageDatesHeaderDiv>
  );
};

export default ShopPageDatesHeaderBox;
